export default __webpack_public_path__ + "static/media/GatcoLogo.ee227c3d.svg";